import script from "./PreviewFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./PreviewFrame.vue?vue&type=script&setup=true&lang=js"

import "./PreviewFrame.vue?vue&type=style&index=0&id=7c4810fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c4810fd"]])

export default __exports__